import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { idCheck, pwCheck } from '../../../js/util'
import { reqData } from '../../../js/server'
import SubBanner from '../../comm/SubBanner';

function JoinStep03(props) {
    const history = useHistory()
    const dispatch = useDispatch()
    const [comInfo, setComInfo] = useState({
        comcode: null,
        comname: null,
        boss: null,
        comidno: null,
        tel0: null,
        tel1: null,
        tel2: null,
        area: null,
        comgrade: null
    })
    const [userId, setUserId] = useState(null)
    const [userName, setUserName] = useState(null)
    const [userPw, setUserPw] = useState(null)
    const [userRePw, setUserRePw] = useState(null)
    const [userTel0, setUserTel0] = useState(null)
    const [userTel1, setUserTel1] = useState(null)
    const [userTel2, setUserTel2] = useState(null)

    const fnSetTel = (e) => {
        if (e.target.id === 'inputHp0') {
            setUserTel0(e.target.value)
            if (e.target.value.length >= 3) {
                document.getElementById('inputHp0').value = e.target.value.slice(0, 3)
                document.getElementById('inputHp1').focus()
            }
        } else if (e.target.id === 'inputHp1') {
            setUserTel1(e.target.value)
            if (e.target.value.length >= 4) {
                document.getElementById('inputHp1').value = e.target.value.slice(0, 4)
                document.getElementById('inputHp2').focus()
            }
        } else if (e.target.id === 'inputHp2') {
            setUserTel2(e.target.value)
            if (e.target.value.length >= 4) {
                document.getElementById('inputHp2').value = e.target.value.slice(0, 4)
            }
        }
    }

    const fnJoinClick = () => {
        const userIdState = idCheck(userId)
        const userPwState = pwCheck(userPw)
        const userRePwState = pwCheck(userRePw)

        if (!userIdState) {
            alert('사용자 아이디는 6~20자내 사용이 가능합니다. (영문,숫자 가능)')
            document.getElementById('inputUserid').focus()
        } else if (!userPwState) {
            alert('사용자 비밀번호는 영문,숫자 포함 6~20자내 사용이 가능합니다.')
            document.getElementById('inputPasswd').focus()
        } else if (!userRePwState) {
            alert('사용자 비밀번호는 6~20자내 사용이 가능합니다.')
            document.getElementById('inputRePasswd').focus()
        } else if (userPw !== userRePw) {
            alert('비밀번호와 비밀번호 확인란의 내용이 다릅니다.')
            document.getElementById('inputRePasswd').focus()
        } else if (!userTel0 || userTel0.length < 3) {
            alert('휴대폰번호는 계정분실시 사용됩니다. 입력해 주세요.')
            document.getElementById('inputHp0').focus()
        } else if (!userTel1 || userTel1.length < 3) {
            alert('휴대폰번호는 계정분실시 사용됩니다. 입력해 주세요.')
            document.getElementById('inputHp1').focus()
        } else if (!userTel2 || userTel2.length < 4) {
            alert('휴대폰번호는 계정분실시 사용됩니다. 입력해 주세요.')
            document.getElementById('inputHp2').focus()
        } else {
            if (window.confirm('가입을 진행하시겠습니까?')) {
                const jsonData = {
                    "servicename": "Regist",
                    "comcode": comInfo.comcode,
                    "userid": userId,
                    "passwd": userPw,
                    "username": userName,
                    "hp": userTel0 + userTel1 + userTel2
                }

                dispatch({ type: 'loadingChange', payload: true })
                reqData(jsonData).then((res) => {
                    if (res.data.result === 'OK') {
                        dispatch({ type: 'authUpdate', payload: res.data.jsonData })
                        localStorage.setItem('userinfo', JSON.stringify(res.data.jsonData))

                        if (!props.aPage) {
                            window.location.href = "/"
                        }
                    } else {
                        alert(res.data.msg)
                    }
                }).catch((err) => {
                    console.error(err)
                }).finally(() => {
                    dispatch({ type: 'loadingChange', payload: false })
                })
            }
        }
    }

    useEffect(() => {
        dispatch({ type: 'pageChange', payload: { 'sub01': '회원가입', 'sub02': '회원가입' } })
        dispatch({ type: 'loadingChange', payload: true })

        setTimeout(() => {
            const _cominfo = localStorage.getItem('authComInfo')
            if (_cominfo) {
                setComInfo(JSON.parse(_cominfo))
            } else {
                alert('조합원 정보가 없습니다. 잘못된 경로를 통해 접근하였습니다.')
                history.push('/JoinStep01')
            }

            dispatch({ type: 'loadingChange', payload: false })
        }, 500)
    },
        [setComInfo, history, dispatch]);

    return (
        <>
            <SubBanner id="member" />

            <section className="appoinment section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-2"></div>

                        <div className="col-lg-6 col-md-8">

                            <div className="row">
                                <div className="joinstep-container">
                                    <div className="joinstep">
                                        <span>01</span>
                                        <span>이용약관동의</span>
                                    </div>
                                    <div className="joinstep">
                                        <span>02</span>
                                        <span>조합원인증</span>
                                    </div>
                                    <div className="joinstep active">
                                        <span>03</span>
                                        <span>회원가입</span>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <p>조합원정보를 확인한 후 회원가입을 진행해 주세요.<br />정보가 다른 경우 조합에 문의해 주시면 수정해 드립니다.</p>
                                </div>
                            </div>

                            <div className="row round-box">
                                <div className="col-lg-12">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label className="form-control-label">업체명</label>
                                                <input id="inputComname" name="inputComname" type="text" className="form-control" readOnly={true} value={comInfo.comname || ''} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label className="form-control-label">대표자명</label>
                                                <input id="inputBoss" name="inputBoss" type="text" className="form-control" readOnly={true} value={comInfo.boss || ''} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label className="form-control-label">연락처</label>
                                                <input id="inputTel" name="inputTel" type="text" className="form-control" readOnly={true} value={`${comInfo.tel0}-${comInfo.tel1}-${comInfo.tel2}` || ''} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label className="form-control-label">사용자아이디</label>
                                                <input id="inputUserid" name="inputUserid" type="text" className="form-control" maxLength="20" onChange={(e) => setUserId(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label className="form-control-label">사용자명</label>
                                                <input id="inputUsername" name="inputUsername" type="text" className="form-control" maxLength="5" onChange={(e) => setUserName(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label className="form-control-label">비밀번호</label>
                                                <input id="inputPasswd" name="inputPasswd" type="password" className="form-control" maxLength="20" onChange={(e) => setUserPw(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label className="form-control-label">비밀번호 확인</label>
                                                <input id="inputRePasswd" name="inputRePasswd" type="password" className="form-control" maxLength="20" onChange={(e) => setUserRePw(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label className="form-control-label">휴대폰번호</label>
                                                <div className="input-group">
                                                    <input id="inputHp0" name="inputHp0" type="number" className="form-control" onChange={fnSetTel} />
                                                    <input id="inputHp1" name="inputHp1" type="number" className="form-control" onChange={fnSetTel} />
                                                    <input id="inputHp2" name="inputHp2" type="number" className="form-control" onChange={fnSetTel} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-lg-12 col-md-12 text-right">
                                            <span className="btn btn-main-2 btn-icon btn-round-full" onClick={fnJoinClick}>가입</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-3 col-md-2"></div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default JoinStep03